import React, { ReactElement, forwardRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MaterialTable, { Icons } from 'material-table';
import { Clear, Search, ToggleOn, ToggleOffOutlined } from '@material-ui/icons';
import { connect } from 'react-redux';
import {
  Button,
  makeStyles,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  Link,
  Tooltip
} from '@material-ui/core';
import './ConfigurationStyle.scss';
import { cellStylesObject } from '../cases/caseStyles';
import {
  getTo4Muscles,
  updateTO4Muscles,
} from '../../../../shared/src/services/AnestheticVitalsService';
import {
  getAnestheticSedativeList,
  updateAnestheticSedativeList,
  getAnestheticNarcoticsList,
  updateAnestheticNarcoticsList
} from '../../../../shared/src/services/SurgeryInductonAnestheticAgents';
import {
  gettEMG,
  updatealltEMG,
  getOtherModality,
  updateOtherModality
} from '../../../../shared/src/services/SurgeryModalities'
import { _snackbarAcknowledgement } from '../../../../shared/src/store/actions/AuthActions';
// import DeleteImage from '../../assets/images/trash.png';
import EditImage from '../../assets/images/edit.svg';
import Arrow from '../../assets/images/arrow-right.png';
import { CONFIGURATIONS } from '../../constants/Configurations';
import AppLoader from '../../components/apploader/AppLoader';
interface RowData {
  id: number | null;
  name: string;
  is_active: boolean;
}

const tEmg = CONFIGURATIONS.TEMG;
const muscleTo4 = CONFIGURATIONS.MUSCLETO4;
const OtherModality = CONFIGURATIONS.OTHER_MODALITY;
const SedativeBolus = CONFIGURATIONS.SEDATIVE_BOLUS;
const Narcotics = CONFIGURATIONS.NARCOTICS;

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiToolbar-regular': {
      minHeight: 0
    },
    '& .MuiOutlinedInput-root': {
      border: 0
    }
  },
  button: {
    borderRadius: 8,
    width: '5.1vw',
    height: '65%',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    float: 'right'
  },
  saveButton: {
    borderRadius: 8,
    width: '6.1vw',
    height: '65%',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    float: 'right',
  },
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      borderRadius: 8,
      boxShadow: '0 10px 30px 0 rgba(0, 0, 0, 0.05)'
    }
  }
}));

const Configurations = (props: any): ReactElement => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [modalState, setModalState] = useState({
    isOpen: false,
    isEdit: false,
    input: '',
    id: -1,
    name:''
  });
  const [deleteState, setDeleteState] = useState<{
    isOpen: boolean;
    rowData: RowData | undefined;
  }>({
    isOpen: false,
    rowData: undefined,
  });
  const [deletedIds, setDeletedIds] = useState<number[]>([]);
  const [selectedPage, setSelectedPage] = useState(tEmg);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = (type: 'add' | 'edit', name: string, rowIndex: number,rowName:string) => {
    setModalState({
      isOpen: true,
      isEdit: type === 'edit',
      input: name,
      id: rowIndex,
      name: rowName,
    });
  };

  // Previously we used to delete name, but now we added activate and deactivate option, so for now we are commenting it.

  // const openDeleteModel = (rowData: RowData) => {
  //   setDeleteState({
  //     isOpen: true,
  //     rowData,
  //   });
  // };

  const closeModal = () => {
    setModalState({ ...modalState, isOpen: false, input: '',name:'' });
  };

  const closeDeleteModel = () => {
    setDeleteState({ ...deleteState, isOpen: false, rowData: undefined });
  };

  const handleModalInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setModalState({ ...modalState, input: event.target.value });
  };

  const optionsObject: any = {
    search: true,
    paging: false,
    header: true,
    headerStyle: {
      color: '#777B7E',
      fontFamily: 'workSansSemiBold',
      height: '3vw',
      fontSize: '0.75vw',
    },
    searchFieldStyle: {
      marginTop: '-5.9vw',
      width: '22vw',
      height: '3vw',
      border: '1px solid #D0D0D0',
      borderRadius: 3,
      backgroundColor: '#FFFFFF',
      paddingLeft: '2%',
      marginRight: '14vw'
    },
    showTitle: false,
    sorting: false,
  };

  const [data, setData] = useState<RowData[]>([]);

  const getConfigurations = async (page: string): Promise<void> => {
    setIsLoading(true);
    try {
      if (page === tEmg) {
        const response = await gettEMG();
        setData(response.data.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
      }
      else if (page === muscleTo4) {
        const response = await getTo4Muscles()
        setData(response.data.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
      }
      else if (page === SedativeBolus) {
        const response = await getAnestheticSedativeList()
        setData(response.data.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
      }
      else if (page === Narcotics) {
        const response = await getAnestheticNarcoticsList()
        setData(response.data.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
      }
      else {
        const response = await getOtherModality()
        setData(response.data.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
      }
    }
    catch (error) {
      setData([]);
      const err = error as any;
      props._snackbarAcknowledgement(
        true,
        err?.message || t('COMMON.GETERROR'),
        t('COMMON.ERRORTEXT')
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getConfigurations(selectedPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPage]);

  const handleDelete = (): void => {
    // Check if the row data is not undefined
    if (deleteState.rowData !== undefined) {
      // Filter the data array to remove the row with the same name as deleteState.rowData.name
      const updatedData = data.filter(item => item.name !== deleteState.rowData?.name);
      // If the id of the row to be deleted is not null, add it to the deletedIds array
      if (deleteState.rowData.id !== null) {
        setDeletedIds(prevDeletedList => [...prevDeletedList, Number(deleteState.rowData?.id)]);
      }
      setData(updatedData);
      closeDeleteModel();
    }
  };

  const handleModalSave = () => {
    if (modalState.isEdit) {
      // Update the name of the edited row in the data array
      const updatedData = data.map(item =>
        item.name === modalState.name ? { ...item, name: modalState.input } : item
      );
      setData(updatedData);
    } else {
      // Add a new row to the data array
      const existingItem = data.find(item => item.name === modalState.input);
      if (!existingItem) {
        const newItem: RowData = { id: null, name: modalState.input, is_active: true};
        setData([newItem, ...data]);
      }
    }
    setModalState({ isOpen: false, isEdit: false, input: '', id: -1,name:'' });
  };

  const handleMoveDown = (rowData: RowData) => {
    // Find the index of the row which to be moved down
    const index = data.findIndex(item => item.name === rowData.name);
    // Check whether the row at index able to be moved
    if (index !== -1 && index < data.length - 1) {
      const updatedData = [...data];
      // Unable to move down if next row not is_active
      if(updatedData[index+1].is_active === true){
        [updatedData[index], updatedData[index + 1]] = [updatedData[index + 1], updatedData[index]];
        setData(updatedData);
      }
    }
  };

  const handleMoveUp = (rowData: RowData) => {
    // Find the index of the row which to be moved up
    const index = data.findIndex(item => item.name === rowData.name);
    // Check whether the row at index able to be moved
    if (index !== -1 && index > 0) {
      const updatedData = [...data];
      [updatedData[index], updatedData[index - 1]] = [updatedData[index - 1], updatedData[index]];
      setData(updatedData);
    }
  };

  const handlePageChange = (name: string) => {
    setSelectedPage(name);
  }

  const handleActivate = (rowData: RowData) => {
    const updatedData = data.map(item => item.name === rowData.name ? { ...item, is_active: !item.is_active } : item);
    setData(updatedData.sort((a, b) => Number(b.is_active) - Number(a.is_active)));
  }

  const handleSave = async (page: string) => {
    setIsLoading(true);
    const filteredData = data.map(item => ({ id: item.id, name: item.name, is_active: item.is_active }));
    if (page === tEmg) {
      try {
        const response = await updatealltEMG(filteredData, deletedIds)
        setIsLoading(false);
        if (response.statusType === "Success") {
          props._snackbarAcknowledgement(
            true,
            t('CONFIGURATIONS.STATUS_SUCCESS'),
            t('COMMON.SUCCESS')
          );
        }
        getConfigurations(page)
      }
      catch (error) {
        const err = error as any;
        setIsLoading(false);
        props._snackbarAcknowledgement(
          true,
          err?.message || t('COMMON.GETERROR'),
          t('COMMON.ERRORTEXT')
        );
        throw error;
      }

    }
    else if (page === muscleTo4) {
      try {
        const response = await updateTO4Muscles(filteredData, deletedIds)
        setIsLoading(false);
        if (response.statusType === "Success") {
          props._snackbarAcknowledgement(
            true,
            t('CONFIGURATIONS.STATUS_SUCCESS'),
            t('COMMON.SUCCESS')
          );
        }
        getConfigurations(page)
      }
      catch (error) {
        setIsLoading(false);
        const err = error as any;
        props._snackbarAcknowledgement(
          true,
          err?.message || t('COMMON.GETERROR'),
          t('COMMON.ERRORTEXT')
        );
        throw error;
      }
    }
    else if (page === SedativeBolus) {
      try {
        const response = await updateAnestheticSedativeList(filteredData, deletedIds)
        setIsLoading(false);
        if (response.statusType === "Success") {
          props._snackbarAcknowledgement(
            true,
            t('CONFIGURATIONS.STATUS_SUCCESS'),
            t('COMMON.SUCCESS')
          );
        }
        getConfigurations(page)
      }
      catch (error) {
        setIsLoading(false);
        const err = error as any;
        props._snackbarAcknowledgement(
          true,
          err?.message || t('COMMON.GETERROR'),
          t('COMMON.ERRORTEXT')
        );
        throw error;
      }
    }
    else if (page === Narcotics) {
      try {
        const response = await updateAnestheticNarcoticsList(filteredData, deletedIds)
        setIsLoading(false);
        if (response.statusType === "Success") {
          props._snackbarAcknowledgement(
            true,
            t('CONFIGURATIONS.STATUS_SUCCESS'),
            t('COMMON.SUCCESS')
          );
        }
        getConfigurations(page)

      }
      catch (error) {
        setIsLoading(false);
        const err = error as any;
        props._snackbarAcknowledgement(
          true,
          err?.message || t('COMMON.GETERROR'),
          t('COMMON.ERRORTEXT')
        );
        throw error;
      }
    }
    else {
      try {
        const response = await updateOtherModality(filteredData, deletedIds)
        setIsLoading(false);
        if (response.statusType === "Success") {
          props._snackbarAcknowledgement(
            true,
            t('CONFIGURATIONS.STATUS_SUCCESS'),
            t('COMMON.SUCCESS')
          );
        }
        getConfigurations(page)
      }
      catch (error) {
        setIsLoading(false);
        const err = error as any;
        props._snackbarAcknowledgement(
          true,
          err?.message || t('COMMON.GETERROR'),
          t('COMMON.ERRORTEXT')
        );
        throw error;
      }
    }
  }
  const renderIcons = (rowData: RowData) => {
    const rowIndex = data.findIndex(item => item.name === rowData.name);
      return (!rowData.is_active ?
        <div className={`row-icons`} >
          <Tooltip title="Inactive">
            <Button onClick={() => handleActivate(rowData)}>
              <ToggleOffOutlined />
            </Button >
          </Tooltip>
        </div> :
        <div className="row-icons">
          <Tooltip title="Active">
            <Button onClick={() => handleActivate(rowData)}>
              <ToggleOn className='toggle' />
            </Button>
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              disabled={!rowData.is_active}>
              <img alt='Edit' src={EditImage} onClick={() => openModal('edit', rowData.name, rowIndex, rowData.name)} />
            </Button>
          </Tooltip>
          {/* Previously we used delete name, but now we added activate and deactivate option, so for now we are commenting it. */}
          {/* <Tooltip title="Delete">
            <Button
              disabled={!rowData.is_active}>
              <img alt='Delete' src={DeleteImage} onClick={() => openDeleteModel(rowData)} className='delete-image' />
            </Button>
          </Tooltip> */}
          <Tooltip title="MoveDown">
            <Button
              disabled={!rowData.is_active}>
              <img alt='Move-Down' src={Arrow} onClick={() => handleMoveDown(rowData)} className='arrow-down' />
            </Button>
          </Tooltip>
          <Tooltip title="MoveUp">
            <Button
              disabled={!rowData.is_active}>
              <img alt='Move-Up' src={Arrow} onClick={() => handleMoveUp(rowData)} />
            </Button>
          </Tooltip>
        </div>
      );
  };

  const tableIcons: Icons = {
    ResetSearch: forwardRef((prop, ref) => <Clear {...prop} ref={ref} />),
    Search: forwardRef((prop, ref) => <Search {...prop} ref={ref} />),
  };

  const renderDialog = (): ReactElement => {
    return (
      <Dialog
        open={modalState.isOpen}
        onClose={closeModal}
        maxWidth={'md'}
        className={classes.dialog}>
        <DialogContent>
          <div className='config-form-container'>
            <div className="title-container">
              <div className="title-view">
                <span className="title-text">
                  {!modalState.isEdit ? t('COMMON.INPUT') : t('COMMON.EDIT')} {selectedPage}
                </span>
              </div>
              <div className="close-view">
                <Link
                  component="button"
                  variant="body2"
                  onClick={closeModal}
                >
                  <span className="close-view-text">
                    {t('PROCEDUREFLOWHEADER.CLOSE')}
                  </span>
                </Link>
              </div>
            </div>
            <div className='text-field-container'>
              <TextField
                className="text-field-input"
                margin="dense"
                variant="outlined"
                id="outlined-textarea"
                type="text"
                fullWidth
                defaultValue={modalState.input}
                value={modalState.input}
                error={data.some((item, index) => {
                  const trimmedInput = modalState.input.trim();
                  return item.name === trimmedInput && index !== modalState.id
                })}
                helperText={data.map((row, index) => {
                  const trimmedInput = modalState.input.trim();
                  return row.name === trimmedInput ? modalState.isEdit && index === modalState.id ? "" : t('CONFIGURATIONS.ADDERRORMESSAGE') : "";
                })}
                onChange={handleModalInputChange}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions className="actions-container">
          <Button
            variant="contained"
            className={[classes.saveButton, 'button'].join(' ')}
            onClick={handleModalSave}
            disabled={data.some((item) => {
              const trimmedInput = modalState.input.trim();
              return item.name === trimmedInput
            }) || modalState.input.trim() === ''}
          >
            <span className="button-text">
              {!modalState.isEdit ? t('COMMON.ADD') : t('COMMON.UPDATE')}
            </span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const deleteDialog = (): ReactElement => {
    return (
      <Dialog
        open={deleteState.isOpen}
        onClose={closeDeleteModel}
        maxWidth={'md'}
        className={classes.dialog}>
        <DialogContent>
          <div className='config-form-container'>
            <div className="title-container">
              <div className="title-view">
                <span className="title-text">
                  {t('COMMON.DELETE')}
                </span>
              </div>
              <div className="close-view">
                <Link
                  component="button"
                  variant="body2"
                  onClick={closeDeleteModel}
                >
                  <span className="close-view-text">
                    {t('PROCEDUREFLOWHEADER.CLOSE')}
                  </span>
                </Link>
              </div>
            </div>
            <div className='text-field-container'>
              <p className='text-field-label'>
                {t('CONFIGURATIONS.DELETECONFIRMTEXT', { name: deleteState.rowData?.name })}
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="actions-container">
          <Button
            variant="contained"
            size="large"
            className={[classes.saveButton, 'button'].join(' ')}
            onClick={() => handleDelete()}>
            <span className="button-text">{t('COMMON.DELETE')}</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return isLoading ? (<AppLoader />) :(
    <div className="configuration-wrapper">
      <div className="configurations-view">
        <div className="configuration-category">
          <div
            className={`configuration-text ${selectedPage === tEmg ? 'active-configuration-text' : ''
              }`}
            onClick={() => handlePageChange(tEmg)}>
            {t('CONFIGURATIONS.TEMG')}
          </div>
          <div
            className={`configuration-text ${selectedPage === muscleTo4 ? 'active-configuration-text' : ''
              }`}
            onClick={() => handlePageChange(muscleTo4)}>
            {t('CONFIGURATIONS.MUSCLETO4')}
          </div>
          <div
            className={`configuration-text ${selectedPage === OtherModality ? 'active-configuration-text' : ''
              }`}
            onClick={() => handlePageChange(OtherModality)}>
            {t('CONFIGURATIONS.OTHER_MODALITY')}
          </div>
          <div
            className={`configuration-text ${selectedPage === SedativeBolus ? 'active-configuration-text' : ''
              }`}
            onClick={() => handlePageChange(SedativeBolus)}>
            {t('CONFIGURATIONS.SEDATIVE_BOLUS')}
          </div>
          <div
            className={`configuration-text ${selectedPage === Narcotics ? 'active-configuration-text' : ''
              }`}
            onClick={() => handlePageChange(Narcotics)}>
            {t('CONFIGURATIONS.NARCOTICS')}
          </div>
        </div>
        <div className="configuration-icons">
          <div className="add-width">
            <Button
              variant="contained"
              size="large"
              className={[classes.button, 'button'].join(' ')} onClick={() => openModal('add', '', -2,'')}
              disabled={isLoading} >
              <span className="button-text">{t('COMMON.ADD')}</span>
            </Button>
          </div>
          <div className="add-width">
            <Button
              variant="contained"
              size="large"
              className={[classes.saveButton, 'button'].join(' ')} onClick={() => handleSave(selectedPage)}
              disabled={isLoading}>
              <span className="button-text">{t('COMMON.SAVE')}</span>
            </Button>
          </div>
        </div>
      </div>
        <div className={classes.root}>
          <MaterialTable
            icons={tableIcons}
            columns={[
              {
                title: 'NAME',
                field: 'name',
                headerStyle: { textAlign: 'left'},
                render: (rowData) => {
                  return (<div className={`table-row ${!rowData.is_active ? 'inactive' : ''}`}>
                          {rowData.name}{renderIcons(rowData)}
                          </div>
                        )
                }
              },
            ]}
            style={{ ...cellStylesObject, maxHeight: '100%' }}
            data={data}
            options={optionsObject}
          />
        </div>
      {renderDialog()}
      {deleteDialog()}
    </div>
  );
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { _snackbarAcknowledgement })(Configurations);